<script>
export default {
  name: 'SidebarBottomIcon',
  props: {
    size: {
      type: [Number, String],
      default: 20,
    },
    colorPrimary: {
      type: String,
      default: 'var(--primary)',
    },
    colorSecondary: {
      type: String,
      default: '#8E8E8E',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.54168 16.5584C2.78335 16.9084 3.09168 17.2167 3.44168 17.4584C4.23335 18.0334 5.26668 18.3334 6.50835 18.3334H13.4917C16.3584 18.3334 18.1334 16.7167 18.3083 13.9834H1.68335C1.75002 15.0084 2.04168 15.8751 2.54168 16.5584Z"
      :fill="colorPrimary"
    />
    <path
      d="M17.4583 3.4415C17.2166 3.0915 16.9083 2.78317 16.5583 2.5415C15.7666 1.9665 14.7333 1.6665 13.4916 1.6665H6.50829C3.47496 1.6665 1.66663 3.47484 1.66663 6.50817V12.7332H18.3333V6.50817C18.3333 5.2665 18.0333 4.23317 17.4583 3.4415ZM12.575 7.9665L10.4416 10.0998C10.2 10.3415 9.79996 10.3415 9.55829 10.0998L7.42496 7.9665C7.29996 7.8415 7.24163 7.68317 7.24163 7.52484C7.24163 7.3665 7.29996 7.19984 7.42496 7.08317C7.66663 6.83317 8.06663 6.83317 8.30829 7.08317L9.99996 8.7665L11.6916 7.07484C11.9333 6.83317 12.3333 6.83317 12.575 7.07484C12.8166 7.3165 12.8166 7.7165 12.575 7.9665Z"
      :fill="colorSecondary"
    />
  </svg>
</template>
